import api from './api';

export interface BankAccountData {
    id?: string;
    bankName: string;
    accountHolder: string;
    iban: string;
    branch?: string;
    description?: string;
    isActive: boolean;
    order: number;
    createdAt?: string;
    updatedAt?: string;
}

export const bankAccountApi = {
    async getAll(): Promise<BankAccountData[]> {
        const response = await api.get('/admin/bank-accounts');
        return response.data.accounts || [];
    },

    async getById(id: string): Promise<BankAccountData> {
        const response = await api.get(`/admin/bank-accounts/${id}`);
        return response.data;
    },

    async create(data: Omit<BankAccountData, 'id' | 'createdAt' | 'updatedAt'>): Promise<{ id: string }> {
        const response = await api.post('/admin/bank-accounts', data);
        return response.data;
    },

    async update(id: string, data: Partial<BankAccountData>): Promise<void> {
        await api.patch(`/admin/bank-accounts/${id}`, data);
    },

    async remove(id: string): Promise<void> {
        await api.delete(`/admin/bank-accounts/${id}`);
    },
};
